import './App.css';
import Home from './Components/Home';
import About from './Components/About';
import Projects from './Components/Projects';
import Awards from './Components/Awards';
import Contact from './Components/Contact';
import { useEffect, useState } from 'react';
import NavBar from './Components/NavBar';
import axios from 'axios';
import Bootloader from './Components/Bootloader';
import Projectmodal from './Components/Cards/ProjectModal';


const API = "api/data.json";

function App() {
  const [data, setData] = useState(null);
  const [showCards, setShowCards] = useState({show:6,total:null});
  const [bootloader, setBootloader] = useState(true);
  const [showMore, setShowMore] = useState(false);

  
  //modal
  const [modalState, setModalState] = useState(false);
  const [modalData, setModalData] = useState(null);

  const toggleBodyOverflow = () =>{
    const body = document.body;
    if(body.classList.contains("overflow-hidden"))
      return body.classList.remove("overflow-hidden")
    return body.classList.add("overflow-hidden")
  }

  const modalToggle = (projectData=null) =>{
    if(projectData)
      setModalData(projectData);
    
    toggleBodyOverflow();
    return setModalState(!modalState);
  }
  // modal end

  useEffect(() => {
    axios.get(API).then(result =>{
      setData(result.data.data);
      setShowCards({...showCards, total: result.data.data.projects.other.projects.length})
      
        // setBootloader(false);
      setTimeout(() => {
          setBootloader(false);
      }, 3500);
    })
  }, []);
  
  
  if(bootloader) return(<Bootloader/>);

  return (
  <>
    {modalState && <Projectmodal stateControl={modalToggle} data={modalData}/>}

    {!modalState && <NavBar/>}

    {/* <div className={modalState?'bg-gray-50 brightness-1  transition ease-in-out duration-500':'bg-gray-50'}> */}
    <div className={modalState?'bg-gray-50 brightness-1  transition ease-in-out duration-500 fade':'bg-gray-50 fade'}>
    {/* <div className='bg-gray-50  fade selection:bg-black selection:text-white'> */}

      <div className='sm:snap-none mx-6 mb-8  sm:mx-32 sm:pt-36 sm:pb-20'>
        {/* content */}

        <div className='home-mobile   sm:grid sm:grid-cols-2 ' >

          <div className=' snap-center snap-always flex items-center h-screen sm:h-auto sm:block'>
            <Home homeData={data.home} socialsData={data.socials}/>
          </div>

          <div className='snap-center snap-always block h-screen sm:h-auto sm:grid' style={{ gridTemplateColumns: '1fr 2fr' }} >
            <div></div>
            <About aboutData={data.about} />
          </div>
        </div>

        {/* projects */}
        <div className='snap-start snap-always'>
          <Projects modalToggle={modalToggle} col={2} projectData={data.projects.featured}/>
          {/* props = true false cols */}
          <Projects  modalToggle={modalToggle} col={3} projectData={data.projects.other} show={showCards.show} otherProject={true} />
          <div className='w-full flex flex-row justify-center'>

            {showCards.show == 6 && <button className="animate-bounce hover:text-white hover:bg-black uppercase text-center text-xs font-openSans font-semibold mt-12 border-2 border-black px-4 py-0.5 m-auto w-max"
              onClick={() =>setShowCards({...showCards ,show: showCards.total})}
            >Show More</button>}
            {/* {showCards.show !== 6 && <button className="hover:text-white hover:bg-black uppercase text-center text-xs font-openSans font-semibold mt-12 border-2 border-black px-4 py-0.5 m-auto w-max"
              onClick={() => setShowCards({...showCards,show:6})}
            >Show Less</button>} */}


          </div>

        </div>

        <div className=''>
          <Awards awardsData={data.awards} />
        </div>


      </div>

      <div className='mt-32'>
      {/* <Divider/> */}
      </div>
      <div className=''>
        <Contact contactData={data.contact}  socialsData={data.socials} aboutData={data.about}/>
      </div>
    </div>
    </>
  );
}

export default App;
